module.exports = __webpack_public_path__ + "img/forbidden.82b67eef.svg";